// @flow

const BUNDLES = {
	AGREE_ON_MEDICAL_SERVICE: 'dms-agree-on-medical-service',
	ARRANGE_VISIT: 'dms-arrange-visit',
	CALLING_DOCTOR: 'dms-calling-doctor',
	PLANNED_HOSPITALIZATION: 'dms-planned-hospitalization',
	FAMILY_INSURANCE: 'dms-family',
	UPGRADE_PROGRAM: 'dms-upgrade-program',
	MEDICAL_REQUEST: 'dms-medical-request',
	AMBULANCE_MAP: 'dms-ambulance-map',
	LABORATORY_RESEARCH: 'dms-laboratory-research',
};

const SYS_NG2 = {
	ENTRYPOINTS: '/media/sys-ng2/dist/entrypoints.json',
	BUNDLES,
};

const SYS_NG3_BUNDLES = {
	CLINICS: 'dms-clinics',
	TELEMED_HUB: 'dms-telemed-hub',
	TELEMEDICINE: 'dms-telemedicine',
};

const SYS_NG3 = {
	ENTRYPOINTS: '/media/sys-ng3/dist/entrypoints.json',
	BUNDLES: SYS_NG3_BUNDLES,
};

export {
	SYS_NG2,
	SYS_NG3,
};
